import React, {useCallback, useContext, useRef, useState} from 'react';
import {useSearchParams} from "react-router-dom";
import {Button} from "primereact/button";
import {Toast} from "primereact/toast";

import {AppContext} from "../../HomePage";
import {isAdmin} from "../../utils/Utils";
import MarketplaceSummary from "./MarketplaceSummary";
import SellerDetail from "./SellerDetail";
import SellerList from "./SellerList";
import SellerSteps from "./SellerSteps";

// The operator's sellers across marketplaces: summary, list, one seller. The level and the list's
// filters live in the URL, so the browser's back button walks up. This screen reads campaign data
// and never writes to it; multipliers and contact details stay in the campaign's Sites step.
const SellerWorkspace = () => {
    const {t} = useContext(AppContext);
    const [params, setParams] = useSearchParams();
    const [reloadKey, setReloadKey] = useState(0);
    const toast = useRef(null);
    const storeId = params.get('store');
    const level = storeId ? 'detail' : (params.get('level') === 'list' ? 'list' : 'summary');

    const onError = useCallback((error) => {
        toast.current?.show({severity: 'error', summary: t('sellers_workspace.error', 'İşlem yapılamadı'),
                             detail: error?.response?.data?.error || error?.message});
    }, [t]);
    const onMatched = useCallback(() => { setReloadKey(key => key + 1); }, []);

    const openList = (filters) => {
        const next = {level: 'list'};
        Object.entries(filters || {}).forEach(([name, value]) => { if (value) next[name] = value; });
        setParams(next);
    };
    const changeFilters = (changed) => {
        openList({marketplace: params.get('marketplace'), filter: params.get('filter'), category: params.get('category'), ...changed});
    };

    return <div className="card">
        <Toast ref={toast}/>
        <div style={{display: 'flex', alignItems: 'center', gap: 6, marginBottom: 14}}>
            {level === 'summary'
                ? <h4 style={{margin: 0}}>{t('sellers_workspace.title', 'Satıcılar')}</h4>
                : <Button label={t('sellers_workspace.title', 'Satıcılar')} className="p-button-link" style={{padding: 0}} onClick={() => setParams({})}/>}
            {level !== 'summary' && <span>›</span>}
            {level === 'list' && <strong>{t('sellers_workspace.list.title', 'Koçtaş satıcıları')}</strong>}
            {level === 'detail' &&
                <Button label={t('sellers_workspace.list.title', 'Koçtaş satıcıları')} className="p-button-link" style={{padding: 0}} onClick={() => openList({})}/>}
        </div>
        {level === 'summary' && <MarketplaceSummary t={t} onOpenList={openList}/>}
        {level === 'list' &&
            <div>
                {isAdmin() && <SellerSteps t={t} toast={toast} onError={onError} onMatched={onMatched}/>}
                <SellerList t={t} toast={toast} onError={onError} reloadKey={reloadKey}
                            marketplace={params.get('marketplace')} filter={params.get('filter')} category={params.get('category')}
                            onFilters={changeFilters} onOpenSeller={(id) => setParams({store: id})}/>
            </div>}
        {level === 'detail' && <SellerDetail key={storeId} t={t} toast={toast} onError={onError} storeId={storeId}/>}
    </div>;
};

export default SellerWorkspace;
